import { useState, useCallback, createContext, useContext } from "react";
import { apiLogout } from "../services/dataSync";

const AuthContext = createContext(null);

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth debe usarse dentro de AuthProvider");
  return ctx;
};

export const AuthProvider = ({ children }) => {
  const [usuario, setUsuario] = useState(null);

  const login = (user) => {
    setUsuario(user);
  };

  const logout = () => {
    apiLogout();
    setUsuario(null);
  };

  const puede = useCallback((accion) => {
    if (!usuario?.rol) return false;
    if (usuario.permisos && typeof usuario.permisos === 'object' && !Array.isArray(usuario.permisos)) return usuario.permisos[accion] || false;
    const permisos = {
      "Administrador": { crear: true, editar: true, eliminar: true, aprobar: true, ver_auditorias: true, gestionar_stock: true },
      "Calidad": { crear: true, editar: true, eliminar: false, aprobar: true, ver_auditorias: true, gestionar_stock: true },
      "Técnico": { crear: true, editar: true, eliminar: false, aprobar: false, ver_auditorias: false, gestionar_stock: false },
      "Dirección": { crear: false, editar: false, eliminar: false, aprobar: true, ver_auditorias: true, gestionar_stock: false },
    };
    return permisos[usuario.rol]?.[accion] || false;
  }, [usuario]);

  return (
    <AuthContext.Provider value={{ usuario, login, logout, loading: false, puede }}>
      {children}
    </AuthContext.Provider>
  );
};